import { IconButton } from '@mui/material'
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded'

export function PlayTTSButton({ startTTS, playing }: { startTTS: () => void; playing: boolean }) {
  return (
    <IconButton
      // aria
      aria-label="Listen to the word or phrase"
      sx={{
        // alignSelf: 'center',
        borderRadius: '16px',
        border: '0.667px solid #EE46BC',
        background: '#F670C7',
        boxShadow: '0px 1px 16px 0px rgba(16, 24, 40, 0.10)',
        '&:hover': {
          borderRadius: '16px',
          border: '0.667px solid #EE46BC',
          background: '#F670C7',
          boxShadow: '0px 1px 16px 0px rgba(16, 24, 40, 0.10)',
        },
      }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        startTTS()
      }}
    >
      {playing ? <VolumeUpRoundedIcon sx={{ color: '#fff', height: 21, width: 21 }} /> : <PlayIcon />}
    </IconButton>
  )
}

function PlayIcon() {
  return (
    <svg fill="none" height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5013 19.0065C15.1037 19.0065 18.8346 15.2756 18.8346 10.6732C18.8346 6.0708 15.1037 2.33984 10.5013 2.33984C5.89893 2.33984 2.16797 6.0708 2.16797 10.6732C2.16797 15.2756 5.89893 19.0065 10.5013 19.0065Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
      <path
        d="M8.41797 8.14429C8.41797 7.74655 8.41797 7.54768 8.50109 7.43666C8.57352 7.33991 8.6844 7.27937 8.80495 7.27076C8.94329 7.26088 9.11057 7.36842 9.44514 7.5835L13.379 10.1124C13.6693 10.299 13.8145 10.3923 13.8646 10.511C13.9084 10.6147 13.9084 10.7317 13.8646 10.8354C13.8145 10.954 13.6693 11.0473 13.379 11.234L9.44514 13.7629C9.11057 13.9779 8.94329 14.0855 8.80495 14.0756C8.6844 14.067 8.57352 14.0064 8.50109 13.9097C8.41797 13.7987 8.41797 13.5998 8.41797 13.2021V8.14429Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  )
}
